import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

// Popovers sit below their anchor (the Add account button is above, in the header) so a tour never covers it.
export const accountsTour: TourDef = {
  id: 'accounts',
  steps: [
    { element: a('accounts-summary'), popover: { title: 'Where you stand', description: 'What you own, what you owe and the difference: your net worth.', side: 'bottom', align: 'start' } },
    { element: a('accounts-add'), popover: { title: 'Add an account', description: 'One place for everything: connect your bank or card, import a statement (like Amex), or add property, loans and cash by hand.', side: 'bottom', align: 'end' } },
    { element: a('accounts-reorder'), popover: { title: 'Your order', description: 'Move accounts up or down so the ones you use most sit at the top.', side: 'left' } },
  ],
};
